import { InputNumber } from "antd";
import TextField2 from "../textfields/TextField2";
import PrimaryButton from "../buttons/PrimaryButton";
import Icon1 from "../icons/Icon";
import SecondaryButton from "../buttons/SecondaryButton";

import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi";
import { useSnackbar } from "notistack";
import { Switch, useTheme } from "@mui/material";
import SmallSpinner from "../loading/SmallSpinner";
import { useNavigate } from "react-router-dom";
import Space from "../layout/Space";
import { use, useEffect, useState } from "react";
import Modal1 from "../modals/Modal1";
import Payment from "./PaymentModal";
import createDocApi from "../api/database/createDocApi";
import { useAppContext } from "../config/AppContext";
import deleteDocApi from "../api/database/deleteDocApi";
import { addActivityLog } from "../config/OnlineStatus";
import { EasySwitch } from "../textfields/EasySwitch";
import WarningButton from "../buttons/WarningButton";
import UploadRapportPayment from "../api/upload/UploadRapportPayment";
import PaymentRapportVisualisateur from "./PaymentRapportVisualisateur";
import {
  getDocDataByRef,
  getFlutterTime,
  queryCollection,
} from "../models/DataFunctions";
import UploadFacturePayment from "../api/upload/UploadFacturePayment";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken";
import { format } from "date-fns";
import { getRefFromId } from "../models/DataFunctions";
import { deleteDoc } from "firebase/firestore";
import sendInfiltreaDeleteMission from "../api/infiltrea/sendInfiltreaDeleteMission";
import sendInfiltreaGetReports from "../api/infiltrea/sendInfiltreaGetReports";
import sendPennylaneDeleteDraftInvoice from "../api/pennylane/sendPennylaneDeleteDraftInvoice";
import sendPennylaneGetInvoiceUrl from "../api/pennylane/sendPennylaneGetInvoiceUrl";
import sendPennylaneFinalizeInvoice from "../api/pennylane/sendPennylaneFinalizeInvoice";
import sendPennylaneSaveInvoiceReglement from "../api/pennylane/sendPennylaneSaveInvoiceReglement";
import DropDownGPT0X from "../dropdowns/DropDownGTP0X";
import updateDocApi from "../api/database/updateDocApi";

const PennylaneFolder = ({ userData, orgData, folderData, handleRefresh }) => {
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const [deleteOpen, setDeleteOpen] = useState(null);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [payment_open, setPaymentOpen] = useState(null);
  const theme = useTheme();
  const [invoices_pennylane, setInvoicesPennylane] = useState([]);
  const [loadingInvoices, setLoadingInvoices] = useState(true);
  const [loadingDeleteMission, setLoadingDeleteMission] = useState(null);
  const [loadingOpenInvoice, setLoadingOpenInvoice] = useState(null);
  const [loadingFinalizeInvoice, setLoadingFinalizeInvoice] = useState(null);
  const [loadingReportsMission, setLoadingReportsMission] = useState(null);
  const [openRapports, setOpenRapports] = useState(null);

  const [loadingData, setLoadingData] = useState(false);
  const [slots_items, setSlotsItems] = useState([]);
  const [selected_slot, setSelectedSlot] = useState(null);
  const handleFetchData = async () => {
    let pennylane_invoices = await queryCollection("pennylane_facture", [
      {
        field: "folder_id",
        operator: "==",
        value: folderData.id,
      },
    ]);

    let slots = [];
    slots = await queryCollection("rapport_slot", [
      {
        field: "folder_ref",
        operator: "==",
        value: folderData.ref,
      },
    ]);

    slots = [
      ...slots,
      await queryCollection("payment", [
        {
          field: "folder_ref",
          operator: "==",
          value: folderData.ref,
        },
      ]),
    ];

    slots = slots.flat().map((s, index) => {
      return {
        value: s.id,
        label:
          s.client_type === "constructor"
            ? s.title || "Emplacement de rapport " + (index + 1)
            : s.title || "Emplacement de paiement " + (index + 1),
      };
    });

    setSlotsItems(slots);
    setInvoicesPennylane(pennylane_invoices);
    setLoadingInvoices(false);
  };

  useEffect(() => {
    if (!folderData) return;
    handleFetchData();
  }, [folderData]);

  const handleOpenInvoice = async (invoice) => {
    setLoadingOpenInvoice(invoice.id);
    const token = await getOrRefreshFirebaseToken();
    let res = await sendPennylaneGetInvoiceUrl(
      invoice.pennylane_facture_id,
      token,
      prefix
    );
    if (res?.url) {
      window.open(res.url, "_blank");
    } else {
      handleClickVariant("Erreur lors de l'ouverture de la facture", "error");
    }
    setLoadingOpenInvoice(null);
  };

  const handleFinalizeInvoice = async (invoice) => {
    setLoadingFinalizeInvoice(invoice.id);
    const token = await getOrRefreshFirebaseToken();
    await sendPennylaneFinalizeInvoice(
      invoice.pennylane_facture_id,
      token,
      prefix
    );
    await updateDocDataFieldApi(
      invoice.ref,
      "finalisation_date",
      getFlutterTime(),
      prefix
    );

    handleClickVariant("Facture Pennylane finalisée", "success");
    handleRefresh();
    setLoadingFinalizeInvoice(null);
  };

  const handleFinaliseFacture = async (invoice) => {
    setLoadingData(true);
    if (!selected_slot) {
      handleClickVariant(
        "Veuillez sélectionner un emplacement de facture",
        "error"
      );
      setLoadingData(false);
      return;
    }
    // finalize the facture
    // get the new pennylane facture id and url
    const token = await getOrRefreshFirebaseToken();
    let res = await sendPennylaneSaveInvoiceReglement(
      folderData.id,
      invoice.pennylane_facture_id,
      selected_slot,
      token,
      prefix
    );
    if (res.success === false) {
      handleClickVariant(
        "Vous devez reconnecter votre compte Pennylane",
        "error"
      );
      navigateWorkspace("/pennylane");
      return;
    } else if (res.success === true) {
      handleClickVariant("Facture enregistrée avec succès", "success");

      // update the facture in the database
      // get the new pennylane facture id and url
      let new_url = res.url;

      let update_body = {
        pennylane_facture_url: new_url,
      };
      await updateDocApi(invoice.ref, update_body, prefix);

      // uload the facture in the slot

      await addActivityLog(
        "Facture Pennylane envoyée vers rapports",
        folderData.ref,
        orgData.id,
        userData.id,
        "pennylane_invoice_sent_to_reports",
        prefix
      );

      // close
      setOpenRapports(null);
      setSelectedSlot(null);
      setLoadingData(false);
      handleRefresh();
    } else {
      handleClickVariant(
        "Erreur lors de l'enregistrement de la facture",
        "error"
      );
      setLoadingData(false);
    }
  };

  const handleDeletePennylaneInvoice = async (invoice) => {
    setLoadingDeleteMission(invoice.id);
    const token = await getOrRefreshFirebaseToken();
    await sendPennylaneDeleteDraftInvoice(
      invoice.pennylane_facture_id,
      token,
      prefix
    );
    let reff = getRefFromId("pennylane_facture", invoice.id);
    await deleteDocApi(reff, prefix);

    handleClickVariant("Facture Pennylane supprimée", "success");
    handleRefresh();
    setLoadingDeleteMission(null);
  };

  if (loadingInvoices) {
    return <SmallSpinner></SmallSpinner>;
  }

  return (
    <div className="flex flex-col h-fit gap-2 justify-end items-start mt-2">
      <Modal1
        isOpen={openRapports !== null}
        onClose={() => setOpenRapports(null)}
      >
        <div className="flex flex-col gap-2 p-4 bg-white rounded-xl w-c400">
          <div className="flex flex-col justify-end gap-2">
            <DropDownGPT0X
              label={"Emplacement de la facture"}
              items={slots_items}
              value={selected_slot}
              mandatory={true}
              onChange={(e) => setSelectedSlot(e.value)}
            ></DropDownGPT0X>{" "}
            <div className="flex flex-row gap-2 w-full justify-between items-center">
              <SecondaryButton
                className={"w-fit"}
                onClick={() => {
                  setOpenRapports(null);
                }}
              >
                Annuler
              </SecondaryButton>
              <PrimaryButton
                className={"w-fit"}
                onClick={() => handleFinaliseFacture(openRapports)}
              >
                Envoyer la facture
                <SmallSpinner loading={loadingData} />
              </PrimaryButton>
            </div>
          </div>{" "}
        </div>
      </Modal1>
      <div className="flex flex-col gap-2 w-full">
        {invoices_pennylane
          .sort((a, b) => b.creation_time - a.creation_time)
          .map((invoice, index) => (
            <div
              key={index}
              className={`flex flex-col border-l-2  space-1  p-2 ${"border-neutral-400 "}`}
            >
              <div className="text-h3 font-light">
                {
                  invoice.type // Convert the Timestamp and format it
                }
                <div className="text-h3 ">
                  {
                    invoice.pdf_invoice_subject // Convert the Timestamp and format it
                  }
                </div>{" "}
              </div>
              {invoice.finalisation_date && (
                <div className="text-h3  text-green-500 my-2 flex flex-row border items-center gap-2 bg-green-50 px-2 py-1 w-fit rounded-lg">
                  <Icon1 icon_name="done2" size={18} fill="#22c55e" />
                  Facture finalisée le{" "}
                  {
                    invoice.finalisation_date &&
                      format(
                        invoice.finalisation_date?.toDate(),
                        "dd/MM/yyyy HH:mm:ss"
                      ) // Convert the Timestamp and format it
                  }
                </div>
              )}
              {!invoice.finalisation_date && (
                <div className="text-h3  text-neutral-400 my-2 border flex flex-row items-center gap-2 bg-neutral-50 px-2 py-1 w-fit rounded-lg">
                  <Icon1 icon_name="done2" size={18} fill="grey" />
                  Facture brouillon
                </div>
              )}
              <div className="text-h3  text-shadow_50">
                Facture créée le{" "}
                {
                  invoice.creation_time &&
                    format(
                      invoice.creation_time?.toDate(),
                      "dd/MM/yyyy HH:mm:ss"
                    ) // Convert the Timestamp and format it
                }
              </div>
              <div className="text-h3 font-light text-shadow_50 mb-2">
                {invoice.invoice_lines && invoice.invoice_lines.length > 0 && (
                  <div className="flex flex-col gap-1">
                    {(
                      invoice.invoice_lines[0].label +
                      " - " +
                      invoice.invoice_lines[0].description
                    ).substring(0, 100) + "..."}
                  </div>
                )}{" "}
              </div>{" "}
              <div className="text-h3 font-light text-shadow_25 ">
                pennylane_facture_id{" "}
                {
                  invoice.pennylane_facture_id // Convert the Timestamp and format it
                }
              </div>{" "}
              <div className="text-h3 font-light text-shadow_25 mb-2">
                hexagone_pennylane_facture_id{" "}
                {
                  invoice.id // Convert the Timestamp and format it
                }
              </div>{" "}
              <div className="flex flex-row gap-2">
                {!invoice.finalisation_date && (
                  <>
                    <SecondaryButton
                      className="h-fit w-fit "
                      disabled={loadingDeleteMission === invoice.id}
                      onClick={() => handleDeletePennylaneInvoice(invoice)}
                    >
                      Supprimer{" "}
                      <SmallSpinner
                        loading={loadingDeleteMission === invoice.id}
                      />
                    </SecondaryButton>
                    <SecondaryButton
                      className="h-fit w-fit "
                      disabled={loadingFinalizeInvoice === invoice.id}
                      onClick={() => handleFinalizeInvoice(invoice)}
                    >
                      Finaliser{" "}
                      <SmallSpinner
                        loading={loadingFinalizeInvoice === invoice.id}
                      />
                    </SecondaryButton>{" "}
                  </>
                )}
                <SecondaryButton
                  className="h-fit w-fit"
                  disabled={!invoice.finalisation_date}
                  onClick={() => setOpenRapports(invoice)}
                >
                  Envoyer vers rapports
                </SecondaryButton>
                <SecondaryButton
                  className="h-fit w-fit "
                  disabled={loadingOpenInvoice === invoice.id}
                  onClick={() => handleOpenInvoice(invoice)}
                >
                  Ouvrir{" "}
                  <SmallSpinner loading={loadingOpenInvoice === invoice.id} />
                </SecondaryButton>
              </div>
            </div>
          ))}
      </div>{" "}
      {invoices_pennylane.length === 0 && (
        <div className="flex flex-col  w-fit rounded-xl items-center h-fit my-1 bg-neutral-50 p-2 border-l-3 border-neutral-400 ">
          <div className="text-h3 text-neutral-400 font-medium   gap-2 flex flex-row items-center">
            <Icon1 icon_name="pennylane" fill="grey" size={18} />
            Aucune facture Pennylane créée pour ce dossier
          </div>
        </div>
      )}
    </div>
  );
};

export default PennylaneFolder;
